(() => {
  const guestActions = {
    '/apps/giftregistry/create': {
      text: 'Oops! Please log in to your account or create a new account in order to create a registry.',
      selector: '.giftreggie-manage-non-customer a',
    },
    '/apps/giftregistry/manage': {
      text: 'Oops! Please log in to your account to manage a registry or create a new account to create a registry.',
      selector: '.giftreggie-manage-non-customer a',
    },
    '/apps/giftregistry/find': {
      text: 'Create a Registry',
      href: '/apps/giftregistry/create',
      selector: '.giftreggie-front.giftreggie-find .giftreggie-footer a',
    },
  };

  if (!guestActions[window.location.pathname]) return;

  const requiredFields = [
    'registry-title',
    'event-date',
    'registrant-first',
    'registrant-last',
    'contact-address',
    'contact-city',
    'contact-country',
    'contact-postal',
  ];

  const addRequiredMarks = () => {
    const form = document.querySelector('#giftreggie-create-form');
    if (!form) return;

    requiredFields.forEach((name) => {
      const field = form.querySelector(`[name="${name}"]`);
      if (!field || field.previousElementSibling?.classList.contains('giftreggie-required-asterisk')) return;

      const mark = document.createElement('span');
      mark.className = 'giftreggie-required-asterisk';
      mark.setAttribute('aria-hidden', 'true');
      mark.textContent = '*';
      field.before(mark);
    });
  };

  const replaceGuestMessage = () => {
    const action = guestActions[window.location.pathname];
    const link = document.querySelector(action.selector);
    if (!link) return;

    link.textContent = action.text;
    if (action.href) link.setAttribute('href', action.href);
  };

  const initGiftRegistry = () => {
    addRequiredMarks();
    replaceGuestMessage();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftRegistry, { once: true });
  } else {
    initGiftRegistry();
  }
})();
